import '../navigation/index';
import '../user-area/index';

import SidebarController from './sidebar.controller';
import SidebarService from './sidebar.service';

angular
	.module('app.sidebar', [
		'app.navigation',
		'app.user-area'
	])
	.component('appSidebar', {
		templateUrl: 'layout/sidebar/sidebar.html',
		controller: SidebarController
	})
	.service('SidebarService', SidebarService);

